/**
 * return a decimal bps discount value
 * @param bps bps discount
 */
export const bpsToDecimal = (bps: number | undefined): number =>
  (bps ?? 0) / 10000;

/**
 * return a percent bps discount value
 * @param bps bps discount
 */
export const bpsToPercent = (bps: number | undefined): number =>
  (bps ?? 0) / 100;
